// extracted by mini-css-extract-plugin
module.exports = {"crumbs":"bread-crumbs_crumbs__kRFeP","crumb":"bread-crumbs_crumb__to_Wc","link":"bread-crumbs_link___3D4e","split":"bread-crumbs_split__P9aXh"};